<template>
  <div
    class="d-flex align-center"
    :class="
      indexInList() && !$vuetify.breakpoint.smAndDown
        ? 'flex-row-reverse'
        : 'flex-row'
    "
  >
    <div
      style="width: 140px; height: 140px; border-radius: 5px"
      class="relative elevation-8 grow overflow-hidden w-full"
    >
      <div
        class="z-index-5 absolute top-0"
        :class="
          indexInList() && !$vuetify.breakpoint.smAndDown
            ? 'right-0 mr-n3 mt-n3'
            : 'ml-n3 mt-n3 left-0'
        "
      >
        <Tooltip
          :right="
            indexInList() && !$vuetify.breakpoint.smAndDown ? false : true
          "
          :text="item.info"
        />
      </div>
      <v-img
        class="w-full h-full object-cover relative z-index-2"
        :src="$connection + item.photoURL"
        :alt="item.title"
      >
        <template v-slot:placeholder>
          <v-row
            class="fill-height ma-0 grey lighten-2"
            align="center"
            justify="center"
          >
            <v-progress-circular
              indeterminate
              color="grey lighten-5"
            ></v-progress-circular>
          </v-row>
        </template>
      </v-img>
    </div>
    <v-btn
      dark
      outlined
      color="primary accent-2"
      tile
      style="background-color: white"
      absolute
      class="z-index-2 text-capitalize elevation-5"
      v-if="!$vuetify.breakpoint.xs"
      :class="
        indexInList() && !$vuetify.breakpoint.smAndDown ? 'mr-24' : 'ml-24'
      "
      >{{ item.title }}</v-btn
    >
    <v-card
      class="relative w-full flex-shrink-1 pa-5 elevation-5" tile
      :class="
        indexInList() && !$vuetify.breakpoint.smAndDown ? 'pr-16' : 'pl-sm-16'
      "
    >
      <div :class="index % 2 ? 'pr-5' : 'pl-sm-5'" class="ellipsis-2">
        {{ item.description }}
      </div>
    </v-card>
  </div>
</template>

<script>
import Tooltip from "@/components/Tooltip";
export default {
  components: {
    Tooltip,
  },
  props: ["item", "index"],
  methods: {
    indexInList() {
      let list = [0, 3, 4, 7, 8, 11, 12, 15, 16];
      return list.includes(this.index);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/main.scss";
</style>